import { createElementBlock as t, openBlock as n, createElementVNode as e } from "vue";
import l from "./index289.js";
const r = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(d, o, f, i, p, m) {
  return n(), t("svg", c, o[0] || (o[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#FFF9D5",
        d: "M45 35.35A15.58 15.58 0 0 1 30.581 45C21.977 45.002 15 38.046 15 29.467 15 21.342 21.26 14.683 29.234 14c-3.97 5.446-3.507 13.104 1.42 18.016 3.882 3.87 9.474 4.97 14.346 3.334Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M29.127 12.755c-8.668.742-15.377 7.985-15.377 16.712 0 9.27 7.538 16.785 16.831 16.783 6.892 0 13.005-4.17 15.575-10.424.407-.991-.539-2.002-1.554-1.66-4.556 1.53-9.615.404-13.066-3.036a12.637 12.637 0 0 1-1.292-16.394c.631-.866-.049-2.073-1.117-1.981Zm13.16 24.477.349-.046-.156.24A14.333 14.333 0 0 1 30.58 43.75c-7.915.002-14.331-6.395-14.331-14.283l.004-.327c.142-6.3 4.396-11.638 10.254-13.363l.266-.075-.141.307a15.137 15.137 0 0 0 3.138 16.892 15.204 15.204 0 0 0 12.517 4.33Z"
      })
    ], -1)
  ]));
}
const u = /* @__PURE__ */ l(r, [["render", s]]);
export {
  u as default
};
